import { mapGetters } from "vuex"

import {
  isBlockActionLink,
  BLOCK_ACTIONS,
  triggerBlockAction
} from "@/lib/stream-utils"
import { isPresent, isWebLink, isBuilderContext } from "@/lib/utils"

export default {
  computed: {
    ...mapGetters(["app"]),
    ...mapGetters("auth", ["currentUser", "hasCheckedAuthentication"]),

    activeProductIds() {
      return isPresent(this.currentUser)
        ? this.currentUser.activeProductIds
        : []
    },

    hasPurchased() {
      if (!this.isTriggerPurchase || !this.blockAction.products) return true

      const productIds = this.blockAction.products.map(item => item.id)

      const hasPurchased = !!this.activeProductIds.find(id =>
        productIds.includes(id)
      )

      return hasPurchased
    },

    isActionQueryPresent() {
      return isPresent(this.$route.query["block-action"])
    },

    isPreview() {
      return isBuilderContext()
    },

    isShareLink() {
      return (
        this.hasBlockAction &&
        this.blockAction.action === BLOCK_ACTIONS.SHARE &&
        isPresent(this.blockAction.url)
      )
    },

    serializedLink() {
      return this.hasBlockAction && isPresent(this.blockAction.link)
        ? this.blockAction.link.replace(this.app?.url || "", "")
        : null
    },

    hasBlockAction() {
      return isPresent(this.blockAction)
    },

    shouldHandleAccess() {
      return (
        this.hasBlockAction &&
        this.blockAction.action === BLOCK_ACTIONS.OPEN_PAGE &&
        isPresent(this.blockAction.page_id)
      )
    },

    pageId() {
      return this.hasBlockAction ? this.blockAction.page_id : null
    },

    isWebLink() {
      return isWebLink(this.serializedLink)
    },

    isTriggerable() {
      return [
        BLOCK_ACTIONS.TRIGGER_FORM,
        BLOCK_ACTIONS.TRIGGER_OVERLAY,
        BLOCK_ACTIONS.TRIGGER_PURCHASE
      ].includes(this.blockAction.action)
    },

    isTriggerPurchase() {
      return (
        this.hasBlockAction &&
        this.blockAction.action === BLOCK_ACTIONS.TRIGGER_PURCHASE
      )
    },

    isLink() {
      const { link, action } = this.blockAction
      return isBlockActionLink(action) && isPresent(link)
    },

    linkTarget() {
      const { link } = this.blockAction
      return isWebLink(link) ? "_blank" : null
    },

    link() {
      return this.blockAction.link || null
    }
  },

  watch: {
    hasCheckedAuthentication: {
      immediate: true,
      handler: function() {
        if (this.hasCheckedAuthentication && this.isTriggerPurchase) {
          this.$emit("purchaseChecked", this.hasPurchased)
        }
      }
    }
  },

  methods: {
    trigger() {
      triggerBlockAction(this.blockAction, this.hasPurchased)
    }
  }
}
